'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var mergeOpts = require('merge-options');

var toMfsPath = require('./utils/to-mfs-path.js');

var ipfsUnixfsExporter = require('ipfs-unixfs-exporter');

var debug = require('debug');

var errCode = require('err-code');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var dagPB = require('@ipld/dag-pb');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var dagPB__namespace = /*#__PURE__*/_interopNamespace(dagPB);

var mergeOptions = mergeOpts__default["default"].bind({
  ignoreUndefined: true
});
var log = debug__default["default"]('ipfs:mfs:stat');
var defaultOptions = {
  withLocal: false
};

function createStat(context) {
  function mfsStat(_x) {
    return _mfsStat.apply(this, arguments);
  }

  function _mfsStat() {
    _mfsStat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
      var options,
          _yield$toMfsPath$toMf,
          type,
          cid,
          mfsPath,
          exportPath,
          file,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              options = mergeOptions(defaultOptions, options);
              log("Fetching stats for ".concat(path));
              _context.next = 5;
              return toMfsPath.toMfsPath(context, path, options);

            case 5:
              _yield$toMfsPath$toMf = _context.sent;
              type = _yield$toMfsPath$toMf.type;
              cid = _yield$toMfsPath$toMf.cid;
              mfsPath = _yield$toMfsPath$toMf.mfsPath;
              exportPath = type === 'ipfs' && cid ? cid : mfsPath;
              _context.prev = 10;
              _context.next = 13;
              return ipfsUnixfsExporter.exporter(exportPath, context.repo.blocks);

            case 13:
              file = _context.sent;
              _context.next = 21;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](10);

              if (!(_context.t0.code === 'ERR_NOT_FOUND')) {
                _context.next = 20;
                break;
              }

              throw errCode__default["default"](new Error("".concat(path, " does not exist")), 'ERR_NOT_FOUND');

            case 20:
              throw _context.t0;

            case 21:
              if (statters[file.type]) {
                _context.next = 23;
                break;
              }

              throw new Error("Cannot stat codec ".concat(file.cid.code));

            case 23:
              return _context.abrupt("return", statters[file.type](file));

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10, 16]]);
    }));
    return _mfsStat.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(mfsStat);
}

var statters = {
  raw: function raw(file) {
    return {
      cid: file.cid,
      size: file.node.length,
      cumulativeSize: file.node.length,
      blocks: 0,
      type: 'file',
      local: undefined,
      sizeLocal: undefined,
      withLocality: false
    };
  },
  file: function file(_file) {
    var stat = {
      cid: _file.cid,
      type: 'file',
      size: _file.unixfs.fileSize(),
      cumulativeSize: dagPB__namespace.encode(_file.node).length + (_file.node.Links || []).reduce(function (acc, curr) {
        return acc + (curr.Tsize || 0);
      }, 0),
      blocks: _file.unixfs.blockSizes.length,
      local: undefined,
      sizeLocal: undefined,
      withLocality: false,
      mode: _file.unixfs.mode
    };

    if (_file.unixfs.mtime) {
      stat.mtime = _file.unixfs.mtime;
    }

    return stat;
  },
  directory: function directory(file) {
    var stat = {
      cid: file.cid,
      type: 'directory',
      size: 0,
      cumulativeSize: dagPB__namespace.encode(file.node).length + (file.node.Links || []).reduce(function (acc, curr) {
        return acc + (curr.Tsize || 0);
      }, 0),
      blocks: file.node.Links.length,
      local: undefined,
      sizeLocal: undefined,
      withLocality: false,
      mode: file.unixfs.mode
    };

    if (file.unixfs.mtime) {
      stat.mtime = file.unixfs.mtime;
    }

    return stat;
  },
  object: function object(file) {
    return {
      cid: file.cid,
      size: file.node.length,
      cumulativeSize: file.node.length,
      type: 'file',
      blocks: 0,
      local: undefined,
      sizeLocal: undefined,
      withLocality: false
    };
  },
  identity: function identity(file) {
    return {
      cid: file.cid,
      size: file.node.length,
      cumulativeSize: file.node.length,
      blocks: 0,
      type: 'file',
      local: undefined,
      sizeLocal: undefined,
      withLocality: false
    };
  }
};
exports.createStat = createStat;